import React from "react";
import ReactDOM from "react-dom";
import LayountMain from "./pslayout";
import LayountAdmin from "./adminlayout";
import Improve from "./improve";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from "react-router-dom";
// import HelmetMetaData from "components/MataManage/HelmetMetaData";
const generateClassName = createGenerateClassName({
  productionPrefix: "psaccApp",
});
require("./_css/BootstrapTable.css");
require("./_css/App.css");

// Suppress deprecated lifecycle warnings from react-bootstrap-table
// The library uses componentWillReceiveProps which is deprecated in React 17+
// This is a temporary solution until the library is updated or replaced
const originalConsoleError = console.error;
console.error = (...args) => {
  try {
    // Build a single string from args (handles Error/objects too)
    const msg = args.map(a => {
      if (typeof a === 'string') return a;
      try { return JSON.stringify(a); } catch (e) { return String(a); }
    }).join(' ');

    // Suppress deprecated lifecycle warnings from third-party libs
    if (msg.includes('componentWillReceiveProps') || msg.includes('componentWillMount') || msg.includes('componentWillUpdate')) {
      return;
    }

    // Suppress React DOM unknown prop warnings we are addressing
    if (msg.includes('React does not recognize the `rtlActive`') ||
        msg.includes('React does not recognize the `autoClose`') ||
        msg.includes('Received `false` for a non-boolean attribute `close`') ||
        msg.includes('React does not recognize the `close`')) {
      return;
    }
  } catch (e) {
    // fallthrough to original
  }
  originalConsoleError.apply(console, args);
};

const getRoute = () => {
  return window.location.pathname !== "/manage";
};
const Improveval = process.env.REACT_APP_IMPROVE;
// Suppress verbose console logging in production or when explicitly disabled
(function setupConsoleSuppress() {
  try {
    // Allow explicit opt-out via REACT_APP_DISABLE_CONSOLE_LOG (true/string 'true')
    const envDisable = process.env.REACT_APP_DISABLE_CONSOLE_LOG === 'true' || process.env.REACT_APP_DISABLE_CONSOLE_LOG === true;
    // Automatically disable verbose logs in production builds
    const isProduction = process.env.NODE_ENV === 'production';
    const shouldDisable = envDisable || isProduction;

    if (shouldDisable) {
      // preserve originals in case we want to re-enable at runtime
      window.__origConsole = window.console;
      // Keep critical warnings/errors but silence verbose output
      window.console = {
        ...window.console,
        log: function () {},
        info: function () {},
        debug: function () {},
      };
    }
  } catch (e) {
    // ignore
  }
})();
ReactDOM.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider
        theme={createTheme({
          typography: { fontFamily: '"Customfont", "Prompt", "mainfont", sans-serif' }
        })}
      >
        <CssBaseline />
        <div className="container">
        {getRoute() ? (
          Improveval !== "true" ? (
            <LayountMain />
          ) : (
            <Improve />
          )
        ) : (
          <LayountAdmin />
        )}
        </div>
      </ThemeProvider>
    </StylesProvider>
  </BrowserRouter>,

  document.getElementById("root")
);
